// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ReportsKpiFilters from './view'

export default function ReportsKpiFiltersFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ReportsKpiFilters">
      <ReportsKpiFilters {...props}>
        {children}
      </ReportsKpiFilters>
    </Flow>
  )
}
